// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"74f7f819","195":"28d74310","315":"a2492062","891":"3b85ef01","941":"17844273"}[chunkId] + ".chunk.js";
};